module.exports = __webpack_public_path__ + "static/media/23-9.5a90b14d.mp3";